export default "__VITE_ASSET__BAcpDnTc__"